const toCsv = (headers, rows) => {
  const escapeCsvValue = value => `"${value.replace(/"/g, '""')}"`;
  const csvRows = [headers.map(escapeCsvValue).join(','), ...rows.map(r => r.map(escapeCsvValue).join(','))];
  return csvRows.join('\n');
};
const downloadCsv = ({
  headers,
  rows,
  filename
}) => {
  const csv = '\uFEFF' + toCsv(headers, rows);
  const blob = new Blob([csv], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => window.URL.revokeObjectURL(url), 250);
};

export { downloadCsv, toCsv };
